/* T-FUNNEL. Native POST stays Shopify-owned. No email, name, or URL query is stored or sent to dataLayer.
   First-touch contract: URL-encoded JSON {utm_source,utm_campaign,utm_content}, 30 days,
   cookie plentum_first_touch_v1. Persist attribution with marketing consent; measure with analytics consent. */
(function () {
  'use strict';
  if (window.__pfCapture) return;
  window.__pfCapture = true;
  var cookieName = 'plentum_first_touch_v1', pendingKey = 'plentum_funnel_pending_v1';
  var keys = ['utm_source', 'utm_campaign', 'utm_content'];
  function analyticsAllowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }
    catch (e) { return false; }
  }
  function marketingAllowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed()); }
    catch (e) { return false; }
  }
  function clean(value) {
    // Reject tag delimiters and personal/contact strings rather than copying them into tags.
    return typeof value === 'string' && /^[a-z0-9][a-z0-9._-]{0,79}$/i.test(value) && !/\d{7,}/.test(value) ? value.toLowerCase() : '';
  }
  function campaign(consentedSignup) {
    var stored = null;
    if (window.Shopify && Shopify.customerPrivacy && !marketingAllowed()) {
      try { document.cookie = cookieName + '=; Max-Age=0; Path=/; SameSite=Lax; Secure'; } catch (e) {}
    }
    try {
      var mayReadExisting = marketingAllowed() || (consentedSignup === true && !(window.Shopify && Shopify.customerPrivacy));
      var entry = mayReadExisting && document.cookie.split(';').map(function (s) { return s.trim(); }).find(function (s) { return s.indexOf(cookieName + '=') === 0; });
      if (entry) stored = JSON.parse(decodeURIComponent(entry.slice(cookieName.length + 1)));
    } catch (e) { /* Invalid cookies never prevent native signup. */ }
    var result = {}, params = new URLSearchParams(location.search);
    keys.forEach(function (key) {
      var value = clean(stored && stored[key]);
      if (!stored) value = clean(params.get(key));
      if (value) result[key] = value;
    });
    if (!stored && Object.keys(result).length && marketingAllowed()) {
      try { document.cookie = cookieName + '=' + encodeURIComponent(JSON.stringify(result)) + '; Max-Age=2592000; Path=/; SameSite=Lax; Secure'; } catch (e) {}
    }
    return result;
  }
  function readPending() { try { return JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (e) { return null; } }
  function clearPending() { try { sessionStorage.removeItem(pendingKey); } catch (e) {} }
  function confirmSuccess(box, form, source) {
    if (box.querySelector('[data-pf-success]') && window.Shopify && Shopify.customerPrivacy) {
        var pending = readPending();
        if (pending && pending.path === location.pathname && pending.form_id === form.id && pending.source_tag === source) {
          clearPending(); // Consume before dispatch, so reloads and repeated section loads cannot duplicate it.
          if (Date.now() - pending.at >= 0 && Date.now() - pending.at < 1800000 && analyticsAllowed()) {
            var event = {event: 'generate_lead', method: 'shopify_customer_form', source_tag: source,
              interest_tag: pending.interest_tag, form_id: form.id};
            keys.forEach(function (key) { var value = clean(pending.campaign && pending.campaign[key]); if (value) event[key] = value; });
            (window.dataLayer = window.dataLayer || []).push(event);
          }
        }
      }
  }
  function init() {
    document.querySelectorAll('[data-pf-capture]').forEach(function (box) {
      if (box.dataset.pfReady) { confirmSuccess(box, box.querySelector('form'), box.dataset.pfSource); return; }
      box.dataset.pfReady = 'true';
      var form = box.querySelector('form'), tags = box.querySelector('[name="contact[tags]"]');
      if (!form || !tags) return;
      var source = box.dataset.pfSource, select = box.querySelector('[data-pf-interest-select]');
      function interest() { return clean(select ? select.value : box.dataset.pfInterest) || 'general'; }
      function update(consentedSignup) {
        var firstTouch = campaign(consentedSignup);
        var values = ['newsletter', source, 'interest:' + interest()];
        if (box.dataset.pfExtraTag) values.push(box.dataset.pfExtraTag);
        keys.forEach(function (key) { if (firstTouch[key]) values.push(key + ':' + firstTouch[key]); });
        tags.value = values.join(',');
      }
      update();
      if (select) select.addEventListener('change', update);
      form.addEventListener('submit', function () {
        var consent = form.querySelector('[name="contact[accepts_marketing]"]');
        if (!form.checkValidity() || !consent || !consent.checked) return;
        update(true); // Explicit signup may use the existing task cookie while consent SDK loads.
        var pending = { source_tag: source, interest_tag: 'interest:' + interest(), form_id: form.id,
          path: location.pathname, at: Date.now(), campaign: campaign(true) };
        try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch (e) {}
      });
      confirmSuccess(box, form, source);
    });
  }
  function boot() {
    init(); // Native form attribution must work while Shopify's consent library is loading.
    if (window.Shopify && !Shopify.customerPrivacy && Shopify.loadFeatures) {
      try { Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.2'}], function () { campaign(); init(); }); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visitorConsentCollected', campaign);
})();
